import { render } from "./AppSection.vue?vue&type=template&id=1a1c489a&ts=true"
import script from "./AppSection.vue?vue&type=script&lang=ts"
export * from "./AppSection.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/package/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__